import React from 'react'
import LeftMenuContextProvider from '../context/LeftMenuContext'
import ProductListContextProvider from '../context/ProductListContext'

function Initialize({children}) {
  return (
    <LeftMenuContextProvider>
      <ProductListContextProvider>
        {children}
      </ProductListContextProvider>
    </LeftMenuContextProvider>
  )
}

export default Initialize